import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnChanges{
  @Input() isLoading: boolean = true;
  isShowLoader: boolean = true;
  constructor() {}

  ngOnChanges(): void {
    if(!this.isLoading) {
      setTimeout(() => {
        this.isShowLoader = false;
      }, 1000);
    }
  }

}
